// eslint-disable-next-line import/no-extraneous-dependencies
import { gql, useQuery } from '@apollo/client';

// Active pathways in the learner's organisation. Row-level permissions on the
// LearningPathways model already scope results to the session org, so no
// explicit organisation filter is needed here.
const GET_DISCOVER_PATHWAYS = gql`
  query GetDiscoverPathways {
    learningPathways(where: { isActive: { _eq: true } }) {
      id
      name
      image
      duration
      durationMetric
      createdAt
    }
  }
`;

export const useDiscoverPathways = (enabled = true) => {
  const { data, loading, error } = useQuery(GET_DISCOVER_PATHWAYS, {
    skip: !enabled,
    fetchPolicy: 'cache-and-network',
  });

  return {
    discoverPathways: data?.learningPathways || [],
    loading,
    error,
  };
};
